export default "__VITE_ASSET__iu1VIggk__"